"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const button_1 = require("components/atoms/button");
require("./pagination.style.css");
const PaginationNumberRender = ({ total, skip, take, onPageChange }) => {
    const [jumpPage, setJumpPage] = (0, react_1.useState)('1');
    const totalPage = Math.ceil(total / take);
    const loopPageItem = totalPage > 6 ? 6 : totalPage;
    const initialArrayPage = new Array(loopPageItem).fill(0)
        .map((_, index) => index === loopPageItem - 1 ? totalPage : index + 1);
    const currentPage = 1 + Math.floor(skip / take);
    const arrayPage = currentPage < 5 ? initialArrayPage :
        (totalPage - currentPage) > 2 ? [
            1, currentPage - 2, currentPage - 1,
            currentPage, currentPage + 1, totalPage
        ] : [
            1, totalPage - 4, totalPage - 3,
            totalPage - 2, totalPage - 1, totalPage
        ];
    const indexSkipFirst = currentPage >= 5 ? 0 : -1;
    const indexSkipLast = (totalPage - currentPage) > 2 ? 4 : -1;
    const movePage = (move) => {
        switch (move) {
            case 'forward': {
                if (currentPage + 1 <= totalPage) {
                    onPageChange(currentPage + 1);
                }
                break;
            }
            case 'backward': {
                if (currentPage - 1 > 0) {
                    onPageChange(currentPage - 1);
                }
                break;
            }
        }
    };
    (0, react_1.useEffect)(() => {
        setJumpPage(currentPage.toString());
    }, [currentPage]);
    const onEnterPageJump = () => {
        const value = parseInt(jumpPage);
        if (value) {
            if (value >= 1 && value <= totalPage) {
                onPageChange(value);
                return;
            }
        }
        setJumpPage(currentPage.toString());
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'pagination-number-container' }, { children: [(0, jsx_runtime_1.jsx)("small", { children: "Page:" }), (0, jsx_runtime_1.jsx)("input", { type: 'number', className: 'pagination-jump-to', onChange: e => setJumpPage(e.target.value), value: jumpPage, onKeyDown: e => e.key === 'Enter' && onEnterPageJump() }), (0, jsx_runtime_1.jsx)(button_1.Clickable, Object.assign({ disable: currentPage === 1, onClick: () => movePage('backward'), className: 'pagination-item p-hover' }, { children: (0, jsx_runtime_1.jsx)("span", { className: 'k-icon k-i-chevron-left' }) })), arrayPage.map((item, index) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(button_1.Clickable, Object.assign({ onClick: () => onPageChange(item), className: `pagination-item p-hover ${currentPage === item ? 'p-selected' : ''}` }, { children: item })), (index === indexSkipFirst || index === indexSkipLast) && ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'pagination-item' }, { children: '...' })))] }, index))), (0, jsx_runtime_1.jsx)(button_1.Clickable, Object.assign({ disable: currentPage === totalPage, onClick: () => movePage('forward'), className: 'pagination-item p-hover' }, { children: (0, jsx_runtime_1.jsx)("span", { className: 'k-icon k-i-chevron-right' }) }))] })));
};
exports.default = PaginationNumberRender;
